var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo01020101(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 499.99999 500.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#1c1c41;}.cls-10,.cls-11,.cls-12,.cls-14,.cls-15,.cls-3,.cls-4,.cls-5,.cls-7,.cls-8{mix-blend-mode:screen;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-13,.cls-16,.cls-6,.cls-9{mix-blend-mode:multiply;opacity:0.37;}.cls-6{fill:url(#linear-gradient-4);}.cls-7,.cls-9{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14,.cls-16{fill:url(#linear-gradient-15);}.cls-15{fill:url(#linear-gradient-16);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 106.19836,
    y1: 292.13467,
    x2: 388.06449,
    y2: 292.13467,
    gradientTransform: "matrix(1, 0, 0, -1, 111.9355, 523.3679)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#882eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e0b60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 106.19836,
    y1: 244.83403,
    x2: 388.06449,
    y2: 244.83403,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 106.19836,
    y1: 244.83403,
    x2: 388.06449,
    y2: 244.83403,
    gradientTransform: "matrix(1, 0, 0, -1, 111.9355, 523.3679)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e0b60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02195,
    stopColor: "#380a56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09212,
    stopColor: "#26073b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17268,
    stopColor: "#180425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26678,
    stopColor: "#0d0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38324,
    stopColor: "#060109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54656,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 222.90722,
    y1: 303.18841,
    x2: 388.06449,
    y2: 303.18841,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 150.41402,
    y1: 361.54279,
    x2: 388.06449,
    y2: 361.54279,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 150.41402,
    y1: 361.54279,
    x2: 388.06449,
    y2: 361.54279,
    gradientTransform: "matrix(1, 0, 0, -1, 111.9355, 523.3679)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#882eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0561,
    stopColor: "#7827dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    stopColor: "#691fbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20016,
    stopColor: "#5b199f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28443,
    stopColor: "#511488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38073,
    stopColor: "#481076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49617,
    stopColor: "#420d69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65001,
    stopColor: "#3f0b62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e0b60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 158.31571,
    y1: 302.08354,
    x2: 440.1819,
    y2: 302.08354,
    gradientTransform: "matrix(-1, 0, 0, 1, 440.1819, -33.3161)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 158.31571,
    y1: 254.7829,
    x2: 440.1819,
    y2: 254.7829,
    gradientTransform: "matrix(-1, 0, 0, 1, 440.1819, -33.3161)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 158.31571,
    y1: 254.7829,
    x2: 440.1819,
    y2: 254.7829,
    gradientTransform: "matrix(-1, 0, 0, 1, 440.1819, -33.3161)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 275.02457,
    y1: 313.13729,
    x2: 440.1819,
    y2: 313.13729,
    gradientTransform: "matrix(-1, 0, 0, 1, 440.1819, -33.3161)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 202.53201,
    y1: 371.49199,
    x2: 440.1819,
    y2: 371.49199,
    gradientTransform: "matrix(-1, 0, 0, 1, 440.1819, -33.3161)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 202.53201,
    y1: 371.49199,
    x2: 440.1819,
    y2: 371.49199,
    gradientTransform: "matrix(-1, 0, 0, 1, 440.1819, -33.3161)",
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.12329.0005H475.87666A24.12333,24.12333,0,0,1,500,24.12383V475.8772a24.1233,24.1233,0,0,1-24.1233,24.1233H24.12329A24.1233,24.1233,0,0,1,0,475.8772V24.1238A24.1233,24.1233,0,0,1,24.12329.0005Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "356.951 209.126 262.35 114.524 405.399 114.524 500 209.126 361.183 347.942 218.134 347.942 356.951 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "500 209.126 356.951 209.126 218.134 347.942 500 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "500 209.126 356.951 209.126 218.134 347.942 500 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "500 209.126 356.951 209.126 334.843 231.233 500 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "500 209.126 346.818 278.534 218.134 347.942 500 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "500 209.126 405.399 114.524 262.35 114.524 500 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "500 209.126 405.399 114.524 262.35 114.524 500 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "500 209.126 356.951 209.126 262.35 114.524 500 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "500 209.126 381.175 156.491 262.35 114.524 500 209.126"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "143.049 290.875 237.65 385.477 94.601 385.477 0 290.875 138.817 152.058 281.866 152.058 143.049 290.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "0 290.875 143.049 290.875 281.866 152.058 0 290.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "0 290.875 143.049 290.875 281.866 152.058 0 290.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "0 290.875 143.049 290.875 165.157 268.767 0 290.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "0 290.875 153.182 221.467 281.866 152.058 0 290.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "0 290.875 94.601 385.477 237.65 385.477 0 290.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 290.875 94.601 385.477 237.65 385.477 0 290.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "0 290.875 143.049 290.875 237.65 385.477 0 290.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "0 290.875 118.825 343.51 237.65 385.477 0 290.875"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01020101);
export default __webpack_public_path__ + "static/media/logo-01-02-01-01.dbdb0b345265c37fff74b019039b5cd5.svg";
export { ForwardRef as ReactComponent };